import { memo } from 'react'
import { isEqual } from 'lodash'
import { PageTitle } from 'app/components/common/PageTitle'
import R from 'app/assets/R'
import { useTranslation } from 'react-i18next'
import JobTitleManagementContainer from 'app/containers/HumanResources/JobTitleManagement'

const JobTitleManagementPageCpn = () => {
  const { t } = useTranslation()
  return (
    <>
      <PageTitle>{t(R.strings.job_title_content_management)}</PageTitle>
      <JobTitleManagementContainer />
    </>
  )
}
const JobTitleManagementPage = memo(JobTitleManagementPageCpn, isEqual)

export default JobTitleManagementPage
